<template>
  <div class="px-4 w-full min-h-screen">
    <div
      class="cloud-hero mb-4 flex flex-wrap z-40 relative text-white bg-norepeat bg-cover"
      :style="{ backgroundImage: 'url(/img/cloud-bg.jpg)' }"
    >
      <div
        class="w-full pt-40 px-6 pb-16 lg:p-16 flex flex-col justify-end text-white"
      >
        <div class="lg:border-l-8 lg:border-white lg:px-8">
          <h1>CareerWise Cloud</h1>
          <h4 v-if="!calendar" class="mb-8">What's happening now</h4>
          <h4 v-else class="mb-8">What's happening now</h4>
          <PostsFilter
            v-if="!calendar"
            :central_cloud="true"
            :parent="component_id"
          />
        </div>
      </div>
    </div>

    <div
      id="posts"
      :class="[loaded ? 'bg-truegray-100' : 'bg-truegray-500']"
      class="w-full px-8 lg:px-16 py-16"
    >
      <div v-show="loaded" class="w-full justify-end">
        <div
          class="btn h-10 w-60 cursor-pointer btn-black ml-auto"
          :class="[calendar ? 'mb-4' : '']"
          @click="toggleCalendar"
        >
          <span v-if="calendar">Card view</span>
          <span v-else>Events Calendar</span>
        </div>

        <div
          v-if="calendar"
          class="btn h-10 w-60 cursor-pointer btn-trans-black ml-auto flex space-x-2 items-center"
          :class="[calendar ? 'btn-trans-black' : 'btn-black']"
          @click="calendar_filters_active = !calendar_filters_active"
        >
          Filters
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-4 h-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
            />
          </svg>
        </div>
      </div>

      <div
        v-if="calendar && calendar_filters_active && loaded"
        class="flex space-x-2"
      >
        <InputDropdownExpanding
          v-if="show_calendar_filter_dd"
          :label="'Region'"
          :options="settings.tag_regions"
          :response-selection-id="'filter_cloud_tag_regions'"
          :is-cloud="true"
          :multiselect="false"
        />
        <button class="btn btn-black h-10" @click="submitCalendarPosts">
          Submit
        </button>
      </div>

      <div
        class="transition-all duration-300 transform"
        :class="[
          loaded ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0',
        ]"
      >
        <div
          v-if="loaded && posts.length > 0 && !calendar"
          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-5 gap-4"
        >
          <PostsCard
            v-for="(post, i) in posts"
            :id="post.id"
            :key="i"
            :ref="'posts-' + i"
            :post="post"
            :cloud="true"
          />
        </div>

        <Calendar
          v-if="loaded && calendar"
          :posts="calendar_posts"
          :cloud="true"
        />
      </div>
      <div
        v-if="!loaded"
        class="h-52 flex flex-col justify-center items-center"
      >
        <lottie :options="loadingAnimationOptions" />
        <span class="text-white text-center">Loading posts</span>
      </div>

      <p v-if="loaded && posts.length < 1" class="text-md">
        We could not find any posts...
      </p>

      <!-- PAGINATION -->
      <div
        v-show="loaded && !calendar"
        v-if="pagination.previouspage || pagination.nextpage"
        class="flex justify-between items-center mt-8 h-10"
      >
        <span
          :disabled="!pagination.previouspage"
          :class="[
            !pagination.previouspage
              ? 'opacity-25 cursor-not-allowed'
              : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
          ]"
          class="text-gray-500"
          @click="getPosts(pagination.previouspage)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 17l-5-5m0 0l5-5m-5 5h12"
            />
          </svg>
        </span>
        <span class="text-center text-xs"
          >Page {{ pagination.current_page }} of
          {{ pagination.total_pages }}</span
        >
        <span
          :disabled="!pagination.nextpage"
          :class="[
            !pagination.nextpage
              ? 'opacity-25 cursor-not-allowed'
              : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
          ]"
          class="text-gray-500"
          @click="getPosts(pagination.nextpage)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </span>
      </div>
    </div>

    <!-- /Posts -->
    <!--
      <div class="w-full mt-4">
      <Registration />
      </div> 
    -->
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { EventBus } from '../../../js/plugins/event-bus.js'
import PostsFilter from '../components/PostsFilter.vue'
import PostsCard from '../../../shared/components/PostsCard.vue'
// import Registration from '../components/Registration.vue'
import InputDropdownExpanding from '../../../shared/components/InputDropdownExpanding.vue'
import Calendar from '../../shared/EventCalendar.vue'
import * as loadingAnimation from '../../../shared/components/loading.json'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    PostsFilter,
    PostsCard,
    // Registration,
    Calendar,
    InputDropdownExpanding,
  },

  mixins: [shared],

  data() {
    return {
      component_id: false,

      loaded: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
      posts: [],
      fromPostCount: 0,

      filter_posts_options: {},

      window: { width: 0, height: 0 },
      footerBG: 'https://source.unsplash.com/random/1920x350',
      inputClass:
        'flex justify-center items-center sm:text-sm text-black focus:text-black active:text-black focus:outline-none active:outline-none transition-all duration-100 ease-in-out rounded bg-white px-4 h-12',

      pagination: {
        current_page: null,
        total_pages: null,
        per_page: 9,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },

      calendar: false,
      calendar_posts: [],
      calendar_filters_active: false,
      show_calendar_filter_dd: true,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      filterCloudBy: 'careerwise/getFilterCloudBy',
    }),
  },

  watch: {
    posts: {
      handler: function () {
        this.setTags()
      },

      deep: true,
    },

    filterCloudBy: {
      handler: function () {
        this.$set(this, 'filter_posts_options', this.filterCloudBy)
      },

      deep: true,
    },

    calendar: {
      handler: function (val) {
        if (!val) {
          return
        }
        this.$set(this, 'loaded', false)
        this.calendar_posts = []
        let submitData = {
          regionId: null,
        }
        axios.post('/api/cloud-calendar-posts', submitData).then((response) => {
          this.$set(this, 'calendar_posts', response.data.posts)
          this.$set(this, 'loaded', true)
        })
      },

      deep: true,
    },
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  mounted() {
    this.dispatchSetFilterCloudBy({ reset: true })
    this.$set(this, 'filter_posts_options', {})

    this.getPosts()

    this.$set(this, 'component_id', this.makeId())
    EventBus.$on('getCloudPostsWithFilterOptions', (data) => {
      if (data.parent === this.component_id) {
        this.getPosts()
      }
    })
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    ...mapActions({
      dispatchSetFilterCloudBy: 'careerwise/dispatchSetFilterCloudBy',
    }),

    toggleCalendar() {
      let status = this.calendar
      this.$set(this, 'calendar', !status)
    },

    submitCalendarPosts() {
      const data = {
        regionId: this.filterCloudBy.region || null,
      }

      axios.post('/api/cloud-calendar-posts', data).then((response) => {
        this.$set(this, 'calendar_posts', response.data.posts)
        this.$set(this, 'loaded', true)
      })
    },

    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },

    resetFilters() {
      EventBus.$emit('resetFilters')
    },

    setTags() {
      if (this.posts.length > 0) {
        this.posts.forEach((post) => {
          //general tags
          if (this.settings.tags && this.settings.tags.length > 0) {
            let general_arr = []
            this.settings.tags.forEach((i) => {
              if (post.tag_titles.includes(i.text)) {
                general_arr.push(i.text)
              }
            })
            post.general_tags = general_arr

            // industry tags
            let industry_arr = []
            this.settings.tag_industries.forEach((i) => {
              if (post.tag_titles.includes(i.text)) {
                industry_arr.push(i.text)
              }
            })
            post.industry_tags = industry_arr
          }

          // Year tags
          if (this.settings.tag_years && this.settings.tag_years.length > 0) {
            let year_arr = []
            this.settings.tag_years.forEach((i) => {
              if (post.tag_titles.includes(i.text)) {
                year_arr.push(i.text)
              }
            })
            post.year_tag = year_arr
          }

          // Region tags
          if (
            this.settings.tag_regions &&
            this.settings.tag_regions.length > 0
          ) {
            let region_arr = []
            this.settings.tag_regions.forEach((i) => {
              if (post.tag_titles.includes(i.text)) {
                region_arr.push(i.text)
              }
            })
            post.region_tag = region_arr
          }
        })
      }
    },

    /**
        ============================ GET POSTS WITH FILTER OPTION ===============
      */
    getPosts(gotopage = null) {
      // If already loaded, assume we are searching or paginating, scroll to posts
      let scrollToPosts = false
      if (this.loaded) {
        scrollToPosts = true
      }

      let submitData = {}

      submitData.search = this.filter_posts_options

      // Pagination page?
      if (gotopage) {
        submitData.page = gotopage
      }

      // Get this post...
      axios.post('/api/cloud-posts', submitData).then((response) => {
        let result = response.data
        if (result.success) {
          this.$set(this, 'posts', result.posts)
          this.$set(this, 'loaded', true)

          // pagination.total = total # of posts. / by per_page, + 1. Pagination doesnt show when not needed so +1 is never wrong on single page
          let total_pages =
            Math.floor(
              response.data.pagination.total /
                response.data.pagination.per_page,
            ) + 1
          this.$set(
            this.pagination,
            'current_page',
            response.data.pagination.current_page,
          )
          this.$set(this.pagination, 'total_pages', total_pages)
          this.$set(
            this.pagination,
            'per_page',
            response.data.pagination.per_page,
          )
          this.$set(
            this.pagination,
            'last_page_url',
            response.data.pagination.last_page_url,
          )
          this.$set(
            this.pagination,
            'next_page_url',
            response.data.pagination.next_page_url,
          )
          this.$set(
            this.pagination,
            'prev_page_url',
            response.data.pagination.prev_page_url,
          )
          this.$set(
            this.pagination,
            'path',
            response.data.pagination.next_page_path,
          )

          let prev = null
          if (this.pagination.prev_page_url) {
            prev = this.pagination.prev_page_url.split('=')
            prev = prev[1]
          }

          let next = null
          if (this.pagination.next_page_url) {
            next = this.pagination.next_page_url.split('=')
            next = next[1]
          }

          this.$set(this.pagination, 'previouspage', prev)
          this.$set(this.pagination, 'nextpage', next)

          // Scroll to posts on pagination and search click
          if (scrollToPosts) {
            this.$scrollTo('#posts')
          }
        } else {
          //...
        }

        EventBus.$emit('filter_posts_search_response_completed')
      })
    },

    deletePost(id) {
      if (!id) {
        return
      }
      axios.get('/api/auth/delete-post/' + id).then((response) => {
        if (response.data.success) {
          this.getPosts()
        }
        if (response.data.alert) {
          EventBus.$emit('triggerAlertResponse', response.data.alert)
        }
        EventBus.$emit('closeOtherPostsManagerMenus')
      })
    },

    editPost(id) {
      if (!id) {
        return
      }
      this.$router.push({ name: 'Post', params: { post_id: id, edit: true } })
    },

    addToNewsletter(id) {
      if (!id) {
        return
      }
      // TBD
    },

    publishPost(id) {
      if (!id) {
        return
      }
      let submitData = new FormData()
      submitData.append('status', 1)
      submitData.append('post_id', id)
      axios.post('/api/auth/update-post', submitData).then((response) => {
        if (response.data.success) {
          this.getPosts()
        } else {
          //...
        }

        if (response.data.alert) {
          EventBus.$emit('triggerAlertResponse', response.data.alert)
        }
      })
    },
  },
}
</script>

<style scoped>
.post-intro::after {
  content: '';
  background: #fff;
  height: 1px;
  width: 500px;
  min-width: 95%;
  position: absolute;
  top: 4rem;
  right: 0;
}
</style>
